{
  "INBOX": {
    "LIST": {
      "TITLE": "Мои Входящие",
      "DISPLAY_DROPDOWN": "Отображать",
      "LOADING": "Загрузка уведомлений",
      "404": "В этой группе нет активных уведомлений.",
      "NO_NOTIFICATIONS": "Уведомления отсутствуют",
      "NOTE": "Уведомления от всех подписанных источников",
      "NO_MESSAGES_AVAILABLE": "Ой! Не удалось получить сообщения",
      "SNOOZED_UNTIL": "Отложить до",
      "SNOOZED_UNTIL_TOMORROW": "Отложено до завтра",
      "SNOOZED_UNTIL_NEXT_WEEK": "Отложено до следующей недели"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Отложить уведомление",
      "DELETE": "Удалить уведомление",
      "BACK": "Назад"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "Вас упомянули в диалоге",
      "CONVERSATION_CREATION": "Диалог создан",
      "CONVERSATION_ASSIGNMENT": "Вам назначен диалог",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Новое сообщение в назначенном диалоге",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Новое сообщение в диалоге, в котором вы участвуете",
      "SLA_MISSED_FIRST_RESPONSE": "Не выполнен целевой срок разрешения по SLA для разговора",
      "SLA_MISSED_NEXT_RESPONSE": "Не выполнен целевой срок следующего ответа по SLA для разговора",
      "SLA_MISSED_RESOLUTION": "Не выполнен целевой срок первого ответа по SLA для разговора"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Упоминания",
      "CONVERSATION_ASSIGNMENT": "Назначено вам",
      "CONVERSATION_CREATION": "Новый диалог",
      "SLA_MISSED_FIRST_RESPONSE": "Нарушение SLA",
      "SLA_MISSED_NEXT_RESPONSE": "Нарушение SLA",
      "SLA_MISSED_RESOLUTION": "Нарушение SLA",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Новое сообщение",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Новое сообщение",
      "SNOOZED_UNTIL": "Отложено до {time}",
      "SNOOZED_ENDS": "Отсрочка закончилась"
    },
    "NO_CONTENT": "Содержимое отсутствует",
    "MENU_ITEM": {
      "MARK_AS_READ": "Отметить как прочитанное",
      "MARK_AS_UNREAD": "Отметить как непрочитанное",
      "SNOOZE": "Отложено",
      "DELETE": "Удалить",
      "MARK_ALL_READ": "Отметить все как прочитанные",
      "DELETE_ALL": "Удалить всё",
      "DELETE_ALL_READ": "Удалить всё прочитанное"
    },
    "DISPLAY_MENU": {
      "SORT": "Сортировка",
      "DISPLAY": "Отображать :",
      "SORT_OPTIONS": {
        "NEWEST": "Самые новые",
        "OLDEST": "Самые старые",
        "PRIORITY": "Приоритет"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Отложено",
        "READ": "Прочитано",
        "LABELS": "Категории",
        "CONVERSATION_ID": "ID диалога"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Уведомление отмечено как прочитанное",
      "MARK_AS_UNREAD": "Уведомление отмечено как непрочитанное",
      "SNOOZE": "Уведомление отложено",
      "DELETE": "Уведомление удалено",
      "MARK_ALL_READ": "Все уведомления отмечены как прочитанные",
      "DELETE_ALL": "Все уведомления удалены",
      "DELETE_ALL_READ": "Все прочитанные уведомления удалены"
    },
    "REAUTHORIZE": {
      "TITLE": "Требуется авторизация",
      "DESCRIPTION": "Время вашего соединения с WhatsApp истекло. Пожалуйста, подключитесь заново, чтобы продолжать получать и отправлять сообщения.",
      "BUTTON_TEXT": "Переподключить WhatsApp",
      "LOADING_FACEBOOK": "Загрузка Facebook SDK...",
      "SUCCESS": "WhatsApp успешно подключен заново",
      "ERROR": "Не удалось перенастроить WhatsApp Business. Пожалуйста, попробуйте еще раз.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID не настроен. Пожалуйста, обратитесь к администратору.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID не настроен. Пожалуйста, обратитесь к администратору.",
      "CONFIGURATION_ERROR": "Произошла ошибка конфигурации при повторной авторизации.",
      "FACEBOOK_LOAD_ERROR": "Не удалось загрузить Facebook SDK. Пожалуйста, попробуйте еще раз.",
      "TROUBLESHOOTING": {
        "TITLE": "Устранение проблем",
        "POPUP_BLOCKED": "Убедитесь, что всплывающие окна разрешены для этого сайта",
        "COOKIES": "Сторонние cookies должны быть включены",
        "ADMIN_ACCESS": "Вам нужен доступ администратора к учетной записи WhatsApp Business"
      }
    }
  }
}
